import { render, staticRenderFns } from "./_base-SideMenu.vue?vue&type=template&id=5982cac0&scoped=true&"
import script from "./_base-SideMenu.vue?vue&type=script&lang=js&"
export * from "./_base-SideMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982cac0",
  null
  
)

export default component.exports